import React, { useCallback, useEffect, useState, useRef } from "react";
import "./DualRangeSlider.css";

const DualRangeSlider = ({ min, max, onChange, filterState }) => {

    const [minVal, setMinVal] = useState(min);
    const [maxVal, setMaxVal] = useState(max);
    const minValRef = useRef(min);
    const maxValRef = useRef(max);
    const range = useRef(null);

    // Convert to percentage
    const getPercent = useCallback(
        (value) => Math.round(((value - min) / (max - min)) * 100),
        [min, max]
    );

    // Set width of the range to decrease from the left side
    useEffect(() => {
        const minPercent = getPercent(minVal);
        const maxPercent = getPercent(maxValRef.current);

        if (range.current) {
            range.current.style.left = `${minPercent}%`;
            range.current.style.width = `${maxPercent - minPercent}%`;
        }
    }, [minVal, getPercent]);

    // Set width of the range to decrease from the right side
    useEffect(() => {
        const minPercent = getPercent(minValRef.current);
        const maxPercent = getPercent(maxVal);

        if (range.current) {
            range.current.style.width = `${maxPercent - minPercent}%`;
        }
    }, [maxVal, getPercent]);

    // Get min and max values when their state changes
    useEffect(() => {
        const timer = setTimeout(() => {
            onChange({ min: minVal, max: maxVal });
        }, 200); // Debounce delay (200ms)

        return () => clearTimeout(timer);
    }, [minVal, maxVal]);

    useEffect(() => {
        setMinVal(filterState?.minAmount)
        setMaxVal(filterState?.maxAmount)
        minValRef.current = filterState?.minAmount;
        maxValRef.current = filterState?.maxAmount;
    }, [filterState?.minAmount, filterState?.maxAmount])
    return (
        <div className="container">
            <input
                type="range"
                min={min}
                max={max}
                value={minVal}
                onChange={(event) => {
                    const value = Math.min(Number(event.target.value), maxVal - 1);
                    setMinVal(value);
                    minValRef.current = value;
                }}
                className="thumb thumb--left"
                style={{ zIndex: minVal > max - 100 && "5" }}
            />
            <input
                type="range"
                min={min}
                max={max}
                value={maxVal}
                onChange={(event) => {
                    const value = Math.max(Number(event.target.value), minVal + 1);
                    setMaxVal(value);
                    maxValRef.current = value;
                }}
                className="thumb thumb--right"
            />

            <div className="slider">
                <div className="slider__track" />
                <div ref={range} className="slider__range" />
                <div className="slider__left-value">{minVal}</div>
                <div className="slider__right-value">{maxVal}</div>
            </div>
        </div>
    );
};

export default DualRangeSlider;




// <Modal open={open} onClose={() => setOpen(false)}>
//         <div className="modal-container">
//           <Box sx={{
//             width: 400, p: 3, bgcolor: "white", borderRadius: 2, position: "relative",

//           }}>
//             <IoClose
//               className="close-icon"
//               size={24}
//               onClick={() => setOpen(false)}
//               style={{ position: "absolute", top: 10, right: 10, cursor: "pointer" }}
//             />
//             <h3>Donation Form</h3>
//             <TextField
//               label="Player Name"
//               name="playerName"
//               fullWidth
//               margin="normal"
//               value={formData.playerName}
//               onChange={handleChange}
//               disabled
//             />
//             <TextField
//               label="Donate Amount"
//               name="donateAmount"
//               fullWidth
//               margin="normal"
//               type="number"
//               onChange={handleChange}
//             />
//             <TextField
//               label="Team Name"
//               name="playerName"
//               fullWidth
//               margin="normal"
//               value={formData.teamName}
//               onChange={handleChange}
//               disabled
//             />


//             {
//               payKey === "transfer" ? <>
//                 <div className="search_filter_player_outer">
//                   <div className="find-loc-input-main search_filter_player_outer" ref={dropdownRef}>
//                     <input
//                       type="search"
//                       className="form-control-input"
//                       value={searchQuery}
//                       onChange={(e) => { setIsSearch(true); setSearchQuery(e?.target?.value) }}
//                       placeholder="Donation Transfer to"
//                       name="search"
//                     />{" "}
//                     {
//                       playerOptions?.length ?
//                         <div className="search_filter_player">
//                           {
//                             playerOptions?.map((item, index) => (
//                               <div className="player_fil-sear" onClick={() => handleSelectedSearchPlayer(item)}>
//                                 {item?.team_name}
//                               </div>
//                             ))
//                           }
//                         </div> : null
//                     }
//                   </div>
//                 </div>
//               </> : null
//             }

//             <div className="buttons-cards-modal">
//               <Button className="submit-modal-card" onClick={handleDonateClick}>
//                 Submit
//               </Button>
//               <Button className="cancel-button-modal" onClick={() => setOpen(false)}>
//                 Cancel
//               </Button>
//             </div>
//           </Box>
//         </div>
//       </Modal >